import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, IEmployeeLinkResponseDto, ILinkedEmployeeInfoDto } from '@/dtos';

import { formatEmployeeData, LinkedAccount } from './useSearchedAccounts.query';

export const GET_LINKED_EMPLOYEES = 'GET_LINKED_EMPLOYEES';

export interface LinkedEmployee {
  linkId?: string;
  primaryEmployeeId?: string;
  linkedEmployees?: LinkedAccount[];
}

const formatData = (data?: IEmployeeLinkResponseDto) =>
  ({
    linkId: data?.link_id,
    primaryEmployeeId: toString(data?.primary_employee_id),
    linkedEmployees: formatEmployeeData((data?.linked_employees || []) as ILinkedEmployeeInfoDto[]),
  }) as LinkedEmployee;

const useLinkedEmployeesQuery = (employeeId?: string) => {
  const { data, isLoading, isSuccess } = useQuery(
    [GET_LINKED_EMPLOYEES, employeeId],
    () => api.get(API_URL.EMPLOYEES_LINK_BY_EMPLOYEE_ID(employeeId || '')),
    { enabled: Boolean(employeeId) }
  );

  const formattedData = useMemo(() => formatData(data?.data), [data]);

  return {
    formattedData,
    isLoading,
    isSuccess,
  };
};

export default useLinkedEmployeesQuery;
